module.exports = require("vtk.js/Sources/Rendering/Misc/GenericRenderWindow");